// imports
import Component from 'minsky-kit/js/components/Component';
import { blockScroll, unblockScroll } from '../utils/scroll';

// class definition
export default class Submenu extends Component {
    // constructor
    constructor (args = {}, objectName = 'Submenu') {
        args.debug = args.debug || false;

        args.states = [
            {
                name:      'show',
                immediate: true,
                steps:     [
                    {
                        name:        'showing',
                        removeClass: ['submenu--state-hidden', 'submenu--state-hiding', 'submenu--state-shown'],
                        addClass:    ['submenu--state-showing'],
                        duration:    0,
                    },
                    {
                        name:        'shown',
                        removeClass: ['submenu--state-showing', 'submenu--state-hidden', 'submenu--state-hiding'],
                        addClass:    ['submenu--state-shown'],
                        duration:    0,
                    },
                ],
            },
            {
                name:      'hide',
                immediate: true,
                steps:     [
                    {
                        name:        'hiding',
                        removeClass: ['submenu--state-shown', 'submenu--state-showing', 'submenu--state-hidden'],
                        addClass:    ['submenu--state-hiding'],
                        duration:    0,
                    },
                    {
                        name:        'hidden',
                        removeClass: ['submenu--state-shown', 'submenu--state-showing', 'submenu--state-hiding'],
                        addClass:    ['submenu--state-hidden'],
                        duration:    500,
                    },
                ],
            },
        ];

        // super
        super(args, objectName);

        this.$triggers = Array.isArray(args.trigger) ? args.trigger : [args.trigger];

        // add internal trigger
        const $closeBtn = this._$el.querySelector('.hamburger');
        if ($closeBtn) this.$triggers.push($closeBtn);

        this.$triggers.forEach(($t) => {
            $t.addEventListener('click', (e) => {
                e.preventDefault();
                this.toggle();
            });
        });

        this.$backdrop = this.$el.querySelector('.submenu__backdrop');
        if (this.$backdrop) this.$backdrop.addEventListener('click', this.blm.add('onBackdropClick', onBackdropClick));
    }

    toggle () {
        this.shown ? this.hide() : this.show();
    }

    show () {
        this.shown = true;
        this.states.set('show');
        this.dispatch('show');

        blockScroll('submenu');
    }

    hide () {
        this.shown = false;
        this.states.set('hide');
        this.dispatch('hide');

        unblockScroll('submenu');
    }

    // methods
    destroy () {
        // super destroy
        super.destroy();
    }

    // getters & setters
}

// Utils

// Event handlers
function onBackdropClick (e) {
    this.hide();
}
